@if (showLastEvent) {
  <div id="event-debugger">{{ message | async | json }}</div>
}
@if (valueDebug) {
  <div id="value-debugger" (tap)="toggleValueDebugger($event)"></div>
}
<div class="router-container">
  @if (((dataAvailable | async) != null || secondDisplay)) {
    <div>
      @if ((dataAvailable | async) || secondDisplay) {
        <router-outlet></router-outlet>
      } @else {
        <div class="ll-container ll-column-ctr nodashboard">
          @if ((dataStatus | async) == DashboardDataStatus.NOT_AVAILABLE) {
            <p>{{ 'STATUS_ERRORS.NOT_AVAILABLE' | translate }}</p>
          }
          @if ((dataStatus | async) == DashboardDataStatus.EXPIRED) {
            <p>{{ 'STATUS_ERRORS.EXPIRED' | translate }}</p>
          }
        </div>
      }
      @if ((dataStatus | async) == DashboardDataStatus.EXPIRED && (dataAvailable | async)) {
        <div class="update">{{ 'STATUS_ERRORS.NOT_UP_TO_DATE' | translate }}</div>
      }
    </div>
  } @else {
    <div id="spinner">
      <ll-spinner></ll-spinner>
    </div>
  }
</div>
